import * as R from 'ramda';
import { OrderProduct, Section } from '../../orderProducts.types';
import { emptyCategory } from '../orderProductsHelpers.utils';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupBySubCategory extends OrderProductsBuilder {
  public group({ orderProducts }: OrderProductsGroupProps): Section[] {
    const groupedProducts = R.groupBy<OrderProduct>(
      (product) => product.category?.id || '',
      orderProducts,
    );

    const groupedProductsToPairs = R.toPairs(groupedProducts);

    return groupedProductsToPairs.map((items) => {
      const products = items[1]!;
      const { category } = products[0];
      return {
        subCategory: category || emptyCategory,
        productsCount: products.length,
        isExpanded: true,
        products,
      };
    });
  }
}

export default OrderProductsGroupBySubCategory;
